import { themeFontFamilies, themeFontStacks } from '@tallyframe/core';
/** The weights every report surface loads: body 400 and 600, mono 400. */
export const THEME_FONT_WEIGHTS = { body: [400, 600], mono: [400] };
/** Inline custom properties for a surface root. Inline style beats
 *  tokens.css's :where() defaults regardless of specificity. */
export function themeStyle(theme) {
    const { body, mono } = themeFontStacks(theme);
    return { '--rp-font': body, '--rp-font-mono': mono };
}
/** CSS font shorthands for document.fonts.load(): weight, px size and the
 *  family in double quotes. A bare family name rejects with a SyntaxError. */
export function fontLoadShorthands(theme, weights = THEME_FONT_WEIGHTS) {
    const { body, mono } = themeFontFamilies(theme);
    return [...weights.body.map((w) => `${w} 16px "${body}"`), ...weights.mono.map((w) => `${w} 16px "${mono}"`)];
}
//# sourceMappingURL=theme-style.js.map